import { useMemo } from 'react';
import { MapContainer, TileLayer, Marker, useMapEvents } from 'react-leaflet';
import L from 'leaflet';
import markerIcon2x from 'leaflet/dist/images/marker-icon-2x.png';
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
import 'leaflet/dist/leaflet.css';

type ClickHandlerProps = {
  onClick: (lat: number, lng: number) => void;
};

const MapClickHandler = ({ onClick }: ClickHandlerProps) => {
  useMapEvents({
    click(e) {
      onClick(e.latlng.lat, e.latlng.lng);
    }
  });
  return null;
};

export type OrderLocationMapProps = {
  center: [number, number];
  marker: [number, number];
  onMapClick: (lat: number, lng: number) => void;
  label: string;
};

export const OrderLocationMap = ({ center, marker, onMapClick, label }: OrderLocationMapProps) => {
  const icon = useMemo(
    () =>
      L.icon({
        iconUrl: markerIcon,
        iconRetinaUrl: markerIcon2x,
        shadowUrl: markerShadow,
        iconSize: [25, 41],
        iconAnchor: [12, 41],
        shadowSize: [41, 41]
      }),
    []
  );

  return (
    <div className="space-y-2">
      <div className="text-xs font-medium text-slate-600">{label}</div>
      <div className="h-[260px] w-full overflow-hidden rounded-lg border border-slate-200 [&_.leaflet-container]:h-full [&_.leaflet-container]:w-full">
        <MapContainer center={center} zoom={13} scrollWheelZoom className="h-full w-full">
          <TileLayer attribution="&copy; OpenStreetMap" url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
          <MapClickHandler onClick={onMapClick} />
          <Marker position={marker} icon={icon} />
        </MapContainer>
      </div>
      <p className="text-xs text-slate-500">Cliquez sur la carte pour positionner le marqueur.</p>
    </div>
  );
};
